const LINK_PREVIEW_API_KEY = process.env.LINK_PREVIEW_API_KEY
const EMBEDLY_API_KEY      = process.env.EMBEDLY_API_KEY

export default class LinkPreview {
  static linkPreview(url) {
    // Free service limited to 60 calls an hour before hitting rate limit.
    return $.ajax({
      type: 'GET',
      url: `https://api.linkpreview.net?key=${LINK_PREVIEW_API_KEY}&q=${encodeURI(url)}`,
      success: response => { return response }
    }).catch(error => {
      return null
    })
  }

  static embedlyPreview(url) {
    return $.ajax({
      type: 'GET',
      url: 'https://api.embedly.com/1/oembed',
      data: {
        url: encodeURI(url),
        key: EMBEDLY_API_KEY,
        words: 20
      },
      success: response => { return response }
    }).catch(error => {
      return null
    })
  }
}
